import { rem } from "@certn/cascadia";
import { useShadows } from "@certn/cascadia-react";
import { css } from "@emotion/css";

export function useMenuStyles() {
  const shadows = useShadows();

  return {
    container: css({
      position: "relative",
    }),
    popover: css({
      display: "block",
      position: "absolute",
      width: "256px",
      right: 0,
      top: "44px",
      padding: `${rem("space-2")} ${rem("space-0")}`,
      boxShadow: shadows["shadow-menu"],
      borderRadius: rem("space-1"),
      zIndex: 11,
    }),
  };
}
